import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { styles } from '../view/styles';
import { WEB_COMPONENT_REMOVE_AD_INTEGRATOR } from '../../../../../../webcomponents.constants';
import { translateFn } from '../../../../../../utils/translator.helper';
import { FontSizes, LineHeights } from '../../../../../../types/common/types';

/**
 * @summary Content of Isolate Endpoint task pop-up.
 * @tag gz-isolate-endpoint-task
 */
@customElement(WEB_COMPONENT_REMOVE_AD_INTEGRATOR)
export class GzRemoveADIntegratorWebComponent extends LitElement {
  // see https://lit-element.polymer-project.org/guide/styles
  static get styles() {
    return styles;
  }

  @property({ type: String })
  public domainName: string;

  render() {
    const mainContent = this.domainName
      ? translateFn(
          'Removing this Active Directory Integrator will stop GravityZone from synchronizing with the domain {DOMAIN_NAME}.',
          { DOMAIN_NAME: this.domainName }
        )
      : translateFn('The selected endpoint will no longer function as an Active Directory Integrator.');

    return html`
      <gz-text lineHeight="${LineHeights.NORMAL}" fontSize="${FontSizes.HEADING_6}">${mainContent}</gz-text>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    WEB_COMPONENT_REMOVE_AD_INTEGRATOR: GzRemoveADIntegratorWebComponent;
  }
}
